import { gql } from '@apollo/client';

import { FileUploadFragment } from './FileUpload.graphql';

export const RdBusinessComponentUploadFragment = gql`
  fragment RdBusinessComponentUpload on RdBusinessComponentUpload {
    id
    status
    isInUse
    rejectionMessage
    fileUpload {
      ...FileUpload
    }
  }
  ${FileUploadFragment}
`;
